import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Tooltip } from '@material-ui/core';

/*
  Usage:
  1) Replace "Template" with actual name (uppercase first letter)
  2) Update props if necessary
  3) Remove this comment
 */

const styles = theme => ({
  root: {},
  missingDataIcon: {
    display: 'flex',
    backgroundColor: theme.palette.warning.main,
    height: 12,
    width: 12,
    borderRadius: '50%',
    marginRight: theme.spacing(1),
  },
});

const MissingDataBubble = ({
  className,
  classes,
  tooltipText,
}) => {
  return (
    <Tooltip
      arrow
      className={classNames(className, classes.root)}
      title={tooltipText}
    >
      <div className={classes.missingDataIcon} />
    </Tooltip>
  );
};

MissingDataBubble.defaultProps = {
  className: '',
};

MissingDataBubble.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  tooltipText: PropTypes.string.isRequired,
};

export default withStyles(styles)(MissingDataBubble);
